import * as ko from "knockout";

export class Comment {

    id: string;
    threadId: string;
    userId: string;
    userName: string;
    userWebsite: string = null;
    userAvatarUrl: string;
    
    createdUtc: string;
    lastModUtc: ko.KnockoutObservable<string> = ko.observable(null);
    // commentHasBeenEdited: any;

    dateDescription: string;
    dateModDescription: any;
    messageHtml: ko.KnockoutObservable<string> = ko.observable(null);
    markdown: ko.KnockoutObservable<string> = ko.observable(null);
    html: ko.KnockoutObservable<string> = ko.observable(null);
    approvedUtc: ko.KnockoutObservable<string> = ko.observable(null);
    showUnapproved: ko.KnockoutObservable<boolean> = ko.observable(false);
    allowReplies: ko.KnockoutObservable<boolean> = ko.observable(true);
    isLocked: ko.KnockoutObservable<boolean> = ko.observable(false);
    tempAllowEdit: ko.KnockoutObservable<boolean> = ko.observable(false);
    depth: number = 1;
    replies: ko.KnockoutObservableArray<Comment> = ko.observableArray();
    replyEditor: any;
    newReply: ko.KnockoutObservable<string> = ko.observable(null);

    isActive: ko.KnockoutObservable<boolean> = ko.observable(false);
    wasActive: ko.KnockoutObservable<boolean> = ko.observable(false);

    parentId: ko.KnockoutObservable<string> = ko.observable(null);
    isAnswer: ko.KnockoutObservable<boolean> = ko.observable(false);
    isMetaComment: ko.KnockoutObservable<boolean> = ko.observable(false);

    votes: ko.KnockoutObservable<number> = ko.observable(0);
    pinned: ko.KnockoutObservable<boolean> = ko.observable(false);
    reported: ko.KnockoutObservable<boolean> = ko.observable(false);
    reportedByCurrentUser: ko.KnockoutObservable<boolean> = ko.observable(false);
    reportedCount: ko.KnockoutObservable<number> = ko.observable(0);

    fnCommentHasBeenEdited = ko.computed(() => {
        let self = this;
        const timeDiff = new Date(self.lastModUtc()).valueOf() - new Date(self.createdUtc).valueOf();
        return timeDiff > 1000;
    }) 

    showTools = ko.computed(() => {
        let self = this;

        if (self.wasActive()) { return true; }

        self.wasActive(self.isActive());

        return self.isActive();

    })

    deleteReply(commentId: string) {
        let self = this;

        self.replies().forEach(function (item: Comment, index) {
            item.deleteReply(commentId);
        });

        self.replies.remove(function (item: Comment) {
            return item.id == commentId;
        });



        
    }

}
